import { InventorySearchEvents } from '@dealersites/inventory/events';
import $ from 'jquery';

// TO DO: modify to target the button that leads to the modal
/**
 * @file
 * Customize the behavior of the SRP search filters.
 */
document.addEventListener('DOMContentLoaded', function () {

  const dspFilters = document.getElementById('dsp-filters');

  if (dspFilters) {
    // Hide any empty filters on page load.
    for (const container of dspFilters.querySelectorAll(`[data-option-count="0"]`)) {
      const id = container.id;
      const filterVisibility = container.closest('.filter-visibility');
      if (!filterVisibility) {
        continue;
      }

      const fallback = filterVisibility.querySelector('.filters__no-options');

      if (fallback) {
        fallback.classList.remove('inactive');
        container.classList.remove('active');
      } else {
        filterVisibility.classList.add('inactive');
        filterVisibility.classList.remove('active');
      }


      $(`button[data-modal-route='${id}-filter']`).addClass('inactive').next('.theme-divider').addClass('inactive');
    

    }

    // Adjust fallback text visibility as the data changes OR hide/show exposed filter
    dspFilters.addEventListener(InventorySearchEvents.POST_SEARCH_FILTER_UPDATE, (e) => {
      const { filter } = e.detail;
      const { container } = filter;
      const id = container.id;


      if ((!'optionCount') in container.dataset) {
        return;
      }

      const optionCount = Number.parseInt(container.dataset.optionCount);
      const filterVisibility = container.closest('.filter-visibility');
      if (!filterVisibility) {
        return;
      }

      const fallback = filterVisibility.querySelector('.filters__no-options');

      let isHidden = false;
      const shouldShowFallback = optionCount < 1;

      if (fallback) {
        isHidden = fallback.classList.contains('inactive');
        if (shouldShowFallback && isHidden) {
          fallback.classList.remove('inactive');
        } else if (!shouldShowFallback && !isHidden) {
          fallback.classList.add('inactive');
          container.classList.remove('inactive');
        } else if (!shouldShowFallback) {
          container.classList.remove('inactive');
        }
      } else {
        if (shouldShowFallback) {
          filterVisibility.classList.add('inactive');
          filterVisibility.classList.remove('active');
        } else {
          filterVisibility.classList.remove('inactive');
          filterVisibility.classList.add('active');
        }
      }


        if (shouldShowFallback) {
          $(`button[data-modal-route='${id}-filter']`).addClass('inactive').next('.theme-divider').addClass('inactive');
        } else {
          $(`button[data-modal-route='${id}-filter']`).removeClass('inactive').next('.theme-divider').removeClass('inactive');
        }
    
    });
  }
});
